<p>asset-type-classification works!</p>
